import { jsonCurrencies } from 'init/json-currencies'
import { currentCurrency } from 'init/current-currency'
import { Currencies } from 'es6/collections/currencies'

/**
 * Инициализация модели валют
 */
export const currencies = new Currencies(jsonCurrencies)
currencies.setCurrent(currentCurrency.name)
